// extracted by mini-css-extract-plugin
export var cardTitle = "_iw-1";
export var commentBubble = "_iw-e";
export var commentForm = "_iw-a";
export var commentInput = "_iw-b";
export var commentLabel = "_iw-d";
export var commentPrompt = "_iw-9";
export var csatCard = "_iw-0";
export var feedbackSection = "_iw-7";
export var starDisabled = "_iw-6";
export var starEmpty = "_iw-5";
export var starFilled = "_iw-4";
export var starWrapper = "_iw-3";
export var starsContainer = "_iw-2";
export var submittedComment = "_iw-c";
export var thankYouText = "_iw-8";